import { Switch, Route, Redirect } from 'react-router-dom';
import LoginForm from './Entry Form/LoginForm';
import Main from './Main/Main';
import MobileMain from './Main/MobileMain';
import JitsiComponent from '../components/JitsiComponent';
import ProtectedRoute from '../components/ProtectedRoute';
import RegisterForm from './Entry Form/RegisterForm';
import ResetPassword from '../components/ResetPassword'
import Home from './Home'
import SetupPassword from './Entry Form/SetupPassword';
import NewPassword from './Entry Form/NewPassword';
import EmailNotice from './Email/EmailNotice';
import { useAuthContext } from '../context/auth';

import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import NotFound from './404NotFound';
import LeaveMeeting from './Virtual Meeting/LeaveMeeting';


const Routes = () => {
  const { user } = useAuthContext();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Switch>
      <Route exact path="/" component={Home}/>
      <Route exact path="/login">
        {!user ? <LoginForm /> : <Redirect to="/messages" />}
      </Route>
      <Route exact path="/register">
        {!user ? <RegisterForm /> : <Redirect to="/messages" />}
      </Route>
      <Route exact path="/setup-password/:token">
        {!user ? <SetupPassword /> : <Redirect to="/messages" />}
      </Route>
      <Route exact path="/new-password/:token">
        {!user ? <NewPassword /> : <Redirect to="/messages" />}
      </Route>
      <Route exact path="/email-confirmation-notice" component={EmailNotice}/>
      <Route exact path="/reset-password" component={ResetPassword}/>

      <ProtectedRoute exact path="/messages" component={isSmallScreen ? MobileMain : Main}/>
      <ProtectedRoute exact path="/virtualroom" component={isSmallScreen ? MobileMain : Main}/>
      <ProtectedRoute exact path="/profile" component={isSmallScreen ? MobileMain : Main}/>
      <ProtectedRoute exact path="/virtualroom/meeting/:id" component={JitsiComponent}/>
      <ProtectedRoute exact path="/virtualroom/meeting-ended" component={LeaveMeeting}/>
      <Route exact path="" component={SetupPassword}/>
      

      <Route component={NotFound} />
    </Switch>
  );
};

export default Routes;
